<template>
  <div class="w-100">
    <b-container fluid>
      <b-row>
        <b-col lg="12">
          <iq-card body-class="p-0">
            <template v-slot:body>
              <div class="iq-edit-list">
                <tab-nav :pills="true" class="iq-edit-profile d-flex">
                  <tab-nav-items
                    class="col-md-4 p-0"
                    :active="activeTab === 'running-hour'"
                    href="#running-hour"
                    title="RUNNING HOUR"
                    @click="activeTab = 'running-hour'"
                  />
                  <tab-nav-items
                    class="col-md-4 p-0"
                    :active="activeTab === 'adjustment-running-hour'"
                    href="#adjustment-running-hour"
                    title="ADJUSTMENT RUNNING HOUR"
                    @click="activeTab = 'adjustment-running-hour'"
                  />
                  <tab-nav-items
                    class="col-md-4 p-0"
                    :active="activeTab === 'goh'"
                    href="#goh"
                    title="ADJUSTMENT KICK OFF GOH"
                    @click="activeTab = 'goh'"
                  />
                </tab-nav>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
    <template v-if="activeTab === 'running-hour'">
      <MainPageRunningHourNew :filters="filters" />
    </template>

    <template v-if="activeTab === 'adjustment-running-hour'">
      <AdjustmentRunningHourNew
        :filters="filters"
      />
    </template>

    <template v-if="activeTab === 'goh'">
      <MainPageGOH
        :filters="filters"
      />
    </template>
  </div>
</template>

<script>
import MainPageRunningHourNew from './RunningHourNew/MainPageRunningHourNew.vue'
import MainPageGOH from './RunningHourNew/MainPageGOH.vue'
import AdjustmentRunningHourNew from './RunningHourNew/AdjustmentRunningHourNew.vue'

export default {
  name: 'RunningHourGOH',
  components: {
    MainPageRunningHourNew,
    MainPageGOH,
    AdjustmentRunningHourNew,
  },
  data() {
    return {
      activeTab: 'running-hour',
      filters: {
        vehicle: [],
        month: new Date(),
      },
    }
  },
}
</script>

<style scoped></style>
